import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

const getCustomerList = (data) => {
  const url = getAgpApiUrl('eservice/diagnose_opportunity', 'ad3_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false).then((res) => {
    const {
      page,
      page_size,
      total_num,
    } = res?.data?.conf || {};
    return {
      ...res,
      data: {
        ...res.data,
        conf: {
          pageCount: page,
          pageSize: page_size,
          totalCount: total_num,
        },
      },
    };
  });
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "conf": {
  //       "pageCount": 1,
  //       "pageIndex": 0,
  //       "pageSize": 20,
  //       "totalCount": 500
  //     },
  //     "list": [
  //       {
  //         "agent_group": "服务商集团",
  //         customer_type: 0,
  //         "asset_name": "string",
  //         "industry_for_business": "string",
  //         "is_frame": "k1",
  //         "marketing_target_id": "名字-111-id",
  //         opportunity_size: 10, // 机会大小 10 较大 1 较小
  //         "ops_advertiser_name": [
  //           "string1",
  //           "string2",
  //         ],
  //         optimization_goal: '10', // 浅层优化目标
  //         partition_time: '2023-12-18',
  //         product_type: '53', // 推广目标
  //         "province_manage": '省份',
  //         "fourteen_day_cost": 123456, // 近14天日均消耗（元）
  //         short_advertiser_name: '百度',
  //         "team": "string",
  //       },
  //       {
  //         "agent_group": "服务商集团",
  //         customer_type: 1,
  //         "asset_name": "string",
  //         "industry_for_business": "string",
  //         "is_frame": "k1",
  //         "marketing_target_id": "名字-111-id",
  //         opportunity_size: 10, // 机会大小 10 较大 1 较小
  //         "ops_advertiser_name": [
  //           "string1",
  //           "string2",
  //         ],
  //         optimization_goal: '10', // 浅层优化目标
  //         partition_time: '2023-12-18',
  //         product_type: '53', // 推广目标
  //         "province_manage": '省份',
  //         "fourteen_day_cost": 123456, // 近14天日均消耗（元）
  //         short_advertiser_name: '百度',
  //         "team": "string",
  //       },
  //     ],
  //   },
  //   "msg": "ok"
  // });
};

const getTotalData = (data) => {
  const url = getAgpApiUrl('eservice/diagnose_opportunity', 'ad3_summary');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, false, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     "large_opportunity_cost": 100, // 最大机会消耗
  //     "large_opportunity_count": 110, // 最大机会数量
  //     "medium_opportunity_cost": 200, // 中等机会消耗
  //     "medium_opportunity_count": 220, // 中等机会数量
  //     "opportunity_cost": 800, // 总机会消耗
  //     "opportunity_count": 880, // 总机会数量
  //     "partition_time": "2023-12-18", // 更新时间
  //     "short_advertiser_name_cost": 1300, // 总客户消耗
  //     "short_advertiser_name_count": 1330, // 总客户数量
  //     "small_opportunity_cost": 300, // 最小机会消耗
  //     "small_opportunity_count": 330, // 最小机会数量
  //   },
  //   "message": "OK"
  // });
};

// 增量机会
const getIncrementList = (data) => {
  const url = getAgpApiUrl('eservice/diagnose_opportunity', 'ad3_new_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );

  return smb_fetch(url, params, true, false);
  // return Promise.resolve({
  //   "code": 0,
  //   "data": {
  //     list: [{
  //       "agent_group": "string",
  //       "asset_name": "string",
  //       "industry_for_business": "string",
  //       "is_frame": "string",
  //       "marketing_target_id": "string",
  //       "opportunity_size": 1,
  //       "ops_advertiser_name": [
  //         "string"
  //       ],
  //       "optimization_goal": 10,
  //       "partition_time": "string",
  //       "product_type": 0,
  //       "province_manage": "string",
  //       "seven_day_cost": 0,
  //       "short_advertiser_name": "string",
  //       "team": "string"
  //     }],
  //   },
  //   "message": "OK"
  // });
};

export default {
  getCustomerList,
  getTotalData,
  getIncrementList,
};
